import React from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Box,
  LinearProgress,
  Divider,
} from "@mui/material";
import {
  Person as PersonIcon,
  Engineering as EngineeringIcon,
} from "@mui/icons-material";
import { useLanguage } from "../context/LanguageContext";

const OperatorStats = ({
  operators = [],
  emptyMessage = "No operators data available",
}) => {
  const { t } = useLanguage();

  // Find max count for percentage calculation
  const maxCount =
    operators.length > 0
      ? Math.max(...operators.map((op) => op.count || 0))
      : 1;

  // If no operators data is available, show fallback message
  if (!operators || operators.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <EngineeringIcon sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
        <Typography color="text.secondary">{emptyMessage}</Typography>
      </Box>
    );
  }

  return (
    <List>
      {operators.map((operator, index) => (
        <React.Fragment key={operator.id || index}>
          <ListItem sx={{ px: 3 }}>
            <ListItemAvatar>
              <Avatar
                src={operator.imgSrc}
                alt={operator.name}
                sx={{ bgcolor: operator.imgSrc ? "inherit" : "primary.main" }}
              >
                {!operator.imgSrc && <PersonIcon />}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography variant="subtitle2" noWrap>
                  {operator.name}
                </Typography>
              }
              secondary={
                <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                  <LinearProgress
                    variant="determinate"
                    value={maxCount > 0 ? (operator.count / maxCount) * 100 : 0}
                    sx={{
                      flexGrow: 1,
                      mr: 1,
                      height: 6,
                      borderRadius: 5,
                    }}
                  />
                  <Typography variant="caption" color="text.secondary">
                    {operator.count} {t("reports")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          {index < operators.length - 1 && (
            <Divider variant="inset" component="li" />
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default OperatorStats;
